import DOMPurify from "dompurify";

/** Shared DOMPurify config — permits the tags our admin editor and Blog posts need,
 *  and strips scripts, event handlers, iframes, objects, embeds, and javascript: URLs. */
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "hr", "div", "span", "section", "article",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "strong", "em", "i", "b", "u", "s", "mark", "small",
    "a", "img",
    "ul", "ol", "li",
    "blockquote", "pre", "code",
    "table", "thead", "tbody", "tr", "th", "td",
    "figure", "figcaption",
  ],
  ALLOWED_ATTR: [
    "href", "target", "rel", "title",
    "src", "alt", "width", "height",
    "class", "style", "id",
    "colspan", "rowspan",
    // Email-safe layout attributes for legacy table-based templates
    // (voucher, invoice, newsletter previews). DOMPurify still strips
    // dangerous attrs like onerror/javascript: URLs regardless.
    "align", "valign", "cellpadding", "cellspacing", "border", "bgcolor", "role",
  ],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "button"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
};

// Force external links to open safely
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.hasAttribute("href")) {
    const href = node.getAttribute("href") || "";
    if (/^https?:\/\//i.test(href)) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  }
});

/** Return a dangerouslySetInnerHTML-compatible object with sanitised HTML. */
export function safeHtml(html) {
  if (!html) return { __html: "" };
  return { __html: DOMPurify.sanitize(String(html), CONFIG) };
}

export default safeHtml;
